<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row" v-if="autoDto.appraisalStatusEnum === 'Rejected'">
                            <div class="col">
                                <div class="alert alert-danger">
                                    <strong>Бекор қилинган!</strong> Баҳолаш жараёни бекор қилинган..
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="pull-left">
                                    <h4 class="card-title float-left">{{$t("auto.title")}}</h4>
                                </div>
                                <div class="pull-right">
                                    <button class="all-btn view-btn" @click="sendMessageFromAndroid">
                                        <i class="fa fa-file-text" v-if="!loadFireBase"></i>
                                        <i v-if="loadFireBase" class="fa fa-spinner fa-spin"></i>
                                        <span> Мобил илова орқали маълумот олиш</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <div class="form-group">
                                    <label>{{$t("realEstate.field.province")}}:</label>
                                    <v-select
                                            label="name"
                                            v-model="autoDto.provinceDto"
                                            :filterable="false"
                                            :options="provinces"
                                            @search="onProvinceSearch"
                                            @search:focus="onProvinceFocus"
                                    >
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>
                                    <div class="red" v-if="$v.autoDto.provinceDto.$error">
                                        {{$t("realEstate.validation.province")}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("auto.selectAuto")}} <span class="red">*</span></label>
                                    <v-select v-model="autoDto.autoTypeDto" label="text"
                                              :options="autoTypeDtos"
                                              :filterable="false"
                                              @search="onAutoTypeSearch"
                                              @search:focus="onAutoTypeFocus"
                                              :class="{invalid : $v.autoDto.autoTypeDto.$error}">
                                        <template slot="option" slot-scope="option" v-if="option">
                                            <div v-html="option.text"></div>
                                        </template>
                                        <template slot="selected-option"
                                                  v-if="autoDto && autoDto.autoTypeDto && autoDto.autoTypeDto.text">
                                            <div v-html="autoDto.autoTypeDto.text"
                                                 @click="$eventBus.$emit('search:focus')"></div>
                                        </template>
                                        <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                    </v-select>

                                    <div class="red" v-if="$v.autoDto.autoTypeDto.$error">
                                        {{$t("auto.selectAuto")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.madeYear")}} <span class="red">*</span></label>
                                    <numeric-input class="form-control" v-model="autoDto.madeYear"
                                                   :class="{invalid : $v.autoDto.madeYear.$error}"
                                                   :controls="false" :precision="0"></numeric-input>
                                    <div class="red" v-if="$v.autoDto.madeYear.$error">
                                        {{$t("auto.madeYear")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.governmentNum")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="autoDto.governmentNum"
                                           :class="{invalid : $v.autoDto.governmentNum.$error}"/>
                                    <div class="red" v-if="$v.autoDto.governmentNum.$error">
                                        {{$t("auto.governmentNum")}}
                                    </div>
                                </div>

                                <div class="form-group"
                                     v-if="hasNotMileage">
                                    <label>{{$t("auto.overpassKm")}} <span class="red">*</span></label>
                                    <numeric-input class="form-control" v-model="autoDto.overpassKm"
                                                   :class="{invalid : $v.autoDto.overpassKm.$error}"
                                                   :controls="false" :precision="0"></numeric-input>
                                    <div class="red" v-if="$v.autoDto.overpassKm.$error">
                                        {{$t("auto.overpassKm")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.engineNum")}} </label>
                                    <input type="text" class="form-control" v-model="autoDto.engineNum"/>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.bodyNum")}} </label>
                                    <input type="text" class="form-control" v-model="autoDto.bodyNum"/>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.shasseNum")}} </label>
                                    <input type="text" class="form-control" v-model="autoDto.shasseNum"/>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("auto.fullWeight")}} </label>
                                    <input type="text" class="form-control" v-model="autoDto.fullWeight"/>
                                </div>
                                <div class="form-group">
                                    <label>{{$t("auto.highWeight")}} </label>
                                    <input type="text" class="form-control" v-model="autoDto.highWeight"/>
                                </div>
                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form-group">
                                    <label>{{$t("auto.technicalConditionReport")}} </label>
                                    <select class="form-control"
                                            v-model="autoDto.technicalConditionReport"
                                            @change="onChangeTechnicalConditionReport">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in technicalConditions" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.electricalComponents")}} </label>
                                    <select class="form-control" v-model="autoDto.electricalComponents">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in autoPartConditions" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.steeringMechanisms")}} </label>
                                    <select class="form-control" v-model="autoDto.steeringMechanisms">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in autoPartConditions" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.engine")}} </label>
                                    <select class="form-control" v-model="autoDto.engine">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in autoPartConditions" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.transmissionBox")}} </label>
                                    <select class="form-control" v-model="autoDto.transmissionBox">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in autoPartConditions" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.saloonParts")}} </label>
                                    <select class="form-control" v-model="autoDto.saloonParts">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in evlAutoSaloonPartConditions" :key="option.id">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.additionalConveniences")}} </label>
                                    <select class="form-control" v-model="autoDto.additionalConveniences">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in additionalConveniences" :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                </div>

                            </div>
                            <div class="col-12 col-md-4">
                                <div class="form-group">
                                    <label>{{$t("auto.technicalConditionOfCar")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="autoDto.technicalConditionOfCar"
                                            :class="{invalid : $v.autoDto.technicalConditionOfCar.$error}"
                                            @change="onChangeTechnicalCondition">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in technicalConditionOfCars"
                                                :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoDto.technicalConditionOfCar.$error">
                                        {{$t("auto.technicalConditionOfCar")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.dilapidationValueByExpert")}} <span class="red">*</span></label>
                                    <select class="form-control" v-model="autoDto.dilapidationValueByExpert"
                                            :class="{invalid : $v.autoDto.dilapidationValueByExpert.$error}">
                                        <option value=""></option>
                                        <option :value="option.key" v-for="option in dilapidationLookupData"
                                                :key="option.key">
                                            {{option.name}}
                                        </option>
                                    </select>
                                    <div class="red" v-if="$v.autoDto.dilapidationValueByExpert.$error">
                                        {{$t("auto.dilapidationValueByExpert")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.texPassportNum")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="autoDto.texPassportNum"
                                           :class="{invalid : $v.autoDto.texPassportNum.$error}"/>
                                    <div class="red" v-if="$v.autoDto.texPassportNum.$error">
                                        {{$t("auto.texPassportNum")}}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t("auto.adress")}} <span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="autoDto.address"
                                           :class="{invalid : $v.autoDto.address.$error}"/>
                                    <div class="red" v-if="$v.autoDto.address.$error">
                                        {{$t("auto.adress")}}
                                    </div>
                                </div>

                                <template v-if="hasNotFuelType">
                                    <div class="form-group">
                                        <label>Ёқилғи тури <span class="red">*</span></label>
                                        <select class="form-control" v-model="autoDto.fuelType">
                                            <option :value="option.key" v-for="option in fuelTypes" :key="option.key">
                                                {{option.name}}
                                            </option>
                                        </select>
                                        <div class="red" v-if="$v.autoDto.fuelType.$error">
                                            Ёқилғи тури
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="autoGasDeviceExist">
                                        <label>Сиғими <span class="red">*</span></label>
                                        <select class="form-control" v-model="autoDto.autoPlusDeviceDto.capacity"
                                                required="">
                                            <option value="30">30 Л</option>
                                            <option value="50">50 Л</option>
                                            <option value="60">60 Л</option>
                                            <option value="65">65 Л</option>
                                            <option value="75">75 Л</option>
                                            <option value="80">80 Л</option>
                                            <option value="90">90 Л</option>
                                            <option value="100">100 Л</option>
                                        </select>
                                        <div class="red" v-if="$v.autoDto.autoPlusDeviceDto.capacity.$error">
                                            Газ балон сиғимини киритинг!
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="autoGasDeviceExist">
                                        <label>Сони <code>*</code></label>
                                        <numeric-input class="form-control" v-model="autoDto.autoPlusDeviceDto.qty"
                                                       :class="{invalid : $v.autoDto.autoPlusDeviceDto.qty.$error}"
                                                       :controls="false" :precision="0"></numeric-input>
                                        <div class="red" v-if="$v.autoDto.autoPlusDeviceDto.qty.$error">
                                            Газ балон сонини киритинг!
                                        </div>
                                    </div>
                                    <div class="form-group" v-if="autoGasDeviceExist">
                                        <label>Эскириш қиймати <span class="red">*</span></label>
                                        <numeric-input class="form-control"
                                                       v-model="autoDto.autoPlusDeviceDto.dilapidationValue"
                                                       :class="{invalid : $v.autoDto.autoPlusDeviceDto.dilapidationValue.$error}"
                                                       :controls="false" :precision="0"></numeric-input>
                                        <div class="red" v-if="$v.autoDto.autoPlusDeviceDto.dilapidationValue.$error">
                                            Газ балон эскириш қиймати
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("auto.autoColor")}} </label>
                                        <input type="text" class="form-control" v-model="autoDto.autoColor"/>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="row">
                            <template v-if="!isPageLoadInit">
                                <AssetDropZone code="texPassportDropZone" label="auto.texPassport"
                                               folder="TexPassport" :folderName="'Auto'"
                                               :data="autoDto.texPassportFiles"
                                               @change="(files) => {autoDto.texPassportFiles = files}"
                                               :has-error="$v.autoDto.texPassportFiles.$error"
                                               :removeFile="canRemoveFile"
                                               :editable="canSave"
                                />
                                <AssetDropZone code="autoImageDropZone" label="auto.photos"
                                               folder="AutoImage" :folderName="'Auto'"
                                               :data="autoDto.autoPhotos"
                                               @change="(files) => {autoDto.autoPhotos = files}"
                                               :has-error="$v.autoDto.autoPhotos.$error"
                                               :removeFile="canRemoveFile"
                                               :editable="canSave"
                                />
                            </template>
                        </div>

                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" v-if="canSave" @click="save" :disabled="processing"
                                >{{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import AssetDropZone from '@/views/asset/AssetDropZone'
    import {required, requiredUnless} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    import fireBaseDb from '@/shared/firebase/firebasedb';
    import {
        EXIST_NOT_EXIST,
        TECHNICAL_CONDITION_OF_CAR,
        AUTO_PART_CONDITIONS,
        AUTO_SALON_PART_CONDITIONS,
        TECHNICAL_CONDITIONS
    } from '@/shared/constants/auto'

    export default {
        name: "LosesAutoItemEdit",
        components: {
            AssetDropZone
        },
        props: {
            objectType: {
                type: String,
                default: null
            },
            parentId: {
                type: String,
                default: null
            },
            id: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                processing: false,
                isPageLoadInit: false,
                numericTypes: numericTypes,
                show: false,
                autoTypeFilter: initFilterModel(),
                autoDto: {
                    id: null,
                    parentId: this.$props.parentId,
                    objectType: this.$props.objectType,
                    approachOne: false,
                    approachThree: false,
                    name: '',
                    autoTypeDto: {},
                    autoPlusDeviceDtos: [],
                    texPassportFiles: [],
                    autoPhotos: [],
                    appraisalStatusEnum: 'Unreviewed',
                    parentAppraisalStatusEnum: 'Unreviewed',
                    parentStatus: 'Pending',
                    autoPlusDeviceDto: {}
                },
                autoTypeDtos: [],
                provinces: [],
                additionalConveniences: EXIST_NOT_EXIST,
                technicalConditionOfCars: TECHNICAL_CONDITION_OF_CAR,
                dilapidationLookupData: [],
                autoPartConditions: AUTO_PART_CONDITIONS,
                evlAutoSaloonPartConditions: AUTO_SALON_PART_CONDITIONS,
                technicalConditions: TECHNICAL_CONDITIONS,
                fuelTypes: [],
                status: null,
                entiteCreateType: null,
                loadFireBase: false,
                fireBaseRequest: {
                    username: null,
                    created_at: new Date(),
                    web_status: 'DEACTIVATED',
                    evlType: 'AUTO',
                    android_status: 'DEACTIVATED',
                    source: "INSIDE",
                    objectId: null,
                    key: null
                },

            }
        },
        validations() {
            return {
                autoDto: {
                    autoTypeDto: {
                        required: required
                    },
                    madeYear: {
                        required: required
                    },
                    provinceDto: {
                        required: required
                    },
                    governmentNum: {
                        required: required
                    },
                    overpassKm: {
                        required: requiredUnless(() => {
                            if (this.autoDto.autoTypeDto.typeOfCar === 'SpecialMachinery' || this.autoDto.autoTypeDto.typeOfCar === 'HalfTrailers' || this.autoDto.autoTypeDto.typeOfCar === 'Trailers') {
                                return true;
                            } else {
                                return false;
                            }
                        })
                    },
                    fuelType: {
                        required: requiredUnless(() => {
                            if (this.autoDto.autoTypeDto.typeOfCar === 'HalfTrailers' || this.autoDto.autoTypeDto.typeOfCar === 'Trailers') {
                                return true;
                            } else {
                                return false;
                            }
                        })
                    },
                    technicalConditionOfCar: {
                        required: required
                    },
                    dilapidationValueByExpert: {
                        required: required
                    },
                    texPassportNum: {
                        required: required
                    },
                    address: {
                        required: required
                    },
                    texPassportFiles: {
                        required: requiredUnless(() => {
                            return this.entiteCreateType === 'EXPERT2';
                        })
                    },
                    autoPhotos: {
                        required: requiredUnless(() => {
                            return this.entiteCreateType === 'EXPERT2';
                        })
                    },
                    autoPlusDeviceDto: {
                        dilapidationValue: {
                            required: requiredUnless(() => {
                                return !this.autoGasDeviceExist;
                            })
                        },
                        capacity: {
                            required: requiredUnless(() => {
                                return !this.autoGasDeviceExist;
                            })
                        },
                        qty: {
                            required: requiredUnless(() => {
                                return !this.autoGasDeviceExist;
                            })
                        }
                    }
                }
            };
        },
        computed: {
            canSave() {
                return (this.autoDto.parentAppraisalStatusEnum === 'Unreviewed' || this.autoDto.parentAppraisalStatusEnum === 'NotFullyEvaluated' || this.autoDto.parentAppraisalStatusEnum === 'SentToComplement');
            },
            autoGasDeviceExist() {
                return this.autoDto.fuelType === 'DIESEL_METHANE' ||
                    this.autoDto.fuelType === 'METAN' ||
                    this.autoDto.fuelType === 'DIESEL_PROPANE' ||
                    this.autoDto.fuelType === 'PROPAN';
            },
            hasNotMileage() {
                return this.autoDto.autoTypeDto && this.autoDto.autoTypeDto.typeOfCar !== 'SpecialMachinery' &&
                    this.autoDto.autoTypeDto.typeOfCar !== 'HalfTrailers' &&
                    this.autoDto.autoTypeDto.typeOfCar !== 'Trailers';
            },
            hasNotFuelType() {
                return this.autoDto.autoTypeDto &&
                    this.autoDto.autoTypeDto.typeOfCar !== 'HalfTrailers' &&
                    this.autoDto.autoTypeDto.typeOfCar !== 'Trailers';
            },
            canRemoveFile() {
                return this.status && this.status !== 'Rated' && this.status !== 'Confirmed' && this.status!=='Rejected' && this.hasPermission('NEW_AUTO_IMAGE_DELETE')
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$props.id;
                vm.entiteCreateType = this.$route.query.entiteCreateType;
                let objectType = "Auto";
                if (id && id > 0) {
                    vm.isPageLoadInit = true;
                    this.$http.get('auto/item/' + id).then(function (data) {
                        vm.autoDto = data.data;
                        if (!vm.autoDto.autoPlusDeviceDto) {
                            vm.autoDto.autoPlusDeviceDto = {};
                        }
                        vm.autoDto.objectType = objectType;
                        if (vm.autoDto.assetItemId) {
                            vm.autoDto.parentId = vm.autoDto.assetItemId;
                        } else if (vm.autoDto.evlObjectId) {
                            vm.autoDto.parentId = vm.autoDto.evlObjectId;
                        }

                        vm.status = data.data.parentAppraisalStatusEnum;
                        vm.isPageLoadInit = false;
                        vm.onChangeTechnicalCondition();
                    });
                }

            },
            cancel() {
                this.$router.push('/auto/loses-edit/' + this.autoDto.parentId);
            },
            save() {
                if (this.autoDto.autoTypeDto.typeOfCar === 'SpecialMachinery' ||
                    this.autoDto.autoTypeDto.typeOfCar === 'HalfTrailers' ||
                    this.autoDto.autoTypeDto.typeOfCar === 'Trailers') {
                    this.autoDto.overpassKm = null;
                }
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                if (this.autoDto.madeYear > new Date().getFullYear()) {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: "Машина ишлаб чиқарилган йили ҳозирги йилдан катта бўлиши мумкин эмас!",
                        type: 'warning'
                    });
                    return;
                }
                this.processing = true;
                this.autoDto.evlObjectId = this.autoDto.parentId;
                this.$http.post('auto/item/save', this.autoDto)
                    .then(res => {
                        if (res.data.status !== 'SUCCESS') {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t(res.data.message),
                                type: 'warning'
                            });
                            return;
                        }
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('auto.success'),
                            type: 'success'
                        });
                        this.autoDto.id = res.data.data;
                        this.processing = false;
                        this.$router.push('/auto/loses-edit/' + this.autoDto.parentId);
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('auto.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            },
            onAutoTypeSearch(searchTxt, loading) {
                loading(true);
                this.autoTypeFilter.search = searchTxt;
                this.searchMethod(loading);
            },
            onProvinceFocus() {
                this.provinces = [];
                this.autoTypeFilter.search = '';
                this.$http.post('/province/list', this.autoTypeFilter)
                    .then(res => {
                        this.provinces = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            onProvinceSearch(searchTxt, loading) {
                loading(true);
                this.provinces = [];
                this.autoTypeFilter.search = searchTxt;
                this.$http.post('/province/list', this.autoTypeFilter)
                    .then(res => {
                        this.provinces = res.data.data;
                        loading(false);
                    }, err => {
                        console.log(err);
                    });
            },
            onAutoTypeFocus() {
                this.autoTypeFilter.search = '';
                this.searchMethod();
            },
            searchMethod(loading) {
                this.autoTypeDtos = [];
                this.$http.post('autoType/searchBy', this.autoTypeFilter)
                    .then(res => {
                        if (loading)
                            loading(false);
                        this.autoTypeDtos = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            getAutoFuelType() {
                this.$http.get('/fuel-type-car').then(response => {
                    this.fuelTypes = response.data;
                }, err => {
                    console.log(err)
                });
            },
            onChangeTechnicalCondition() {
              this.dilapidationLookupData = [];
              if (this.autoDto != null && this.autoDto.technicalConditionOfCar != null) {
                const vm = this;
                this.$http.get('/dilapidation-value-expert/' + this.autoDto.technicalConditionOfCar)
                    .then(res => {
                      vm.dilapidationLookupData = res.data;

                    }, err => {
                      console.log(err);
                    });
              }
            },

            onChangeTechnicalConditionReport() {
                if (this.autoDto.technicalConditionReport === "Accessible") {
                    this.autoDto.electricalComponents = "Accessible";
                    this.autoDto.steeringMechanisms = "Accessible";
                    this.autoDto.engine = "Accessible";
                    this.autoDto.transmissionBox = "Accessible";
                    this.autoDto.saloonParts = "Accessible";
                }
            },

            sendMessageFromAndroid() {
                const username = this.$store.state.profile.username;
                this.onEditFireBase(username)
            },
            onEditFireBase(username) {
                let dbRef =  fireBaseDb.collection("users_auto")
                let isDataAvailable = false
                dbRef.where("username", "==", username).get()
                    .then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            if (doc.data()) {
                                console.log('firebase edit =', doc.data())
                                if (doc.data().web_status === 'DEACTIVATED') {
                                    this.onUpdateFireBase(doc.id)
                                }
                                isDataAvailable = true
                            }
                        });
                        if (!isDataAvailable) {
                            this.onWriteFireBase(username)
                        }
                    }).catch((error) => {
                    console.log(error);
                });
            },
            onUpdateFireBase(key) {
                fireBaseDb.collection("users_auto").doc(key)
                    .update({web_status: "ACTIVE", evlType: 'AUTO', source: "INSIDE", android_status : 'DEACTIVATED', objectId : this.autoDto && this.autoDto.parentId ? `${this.autoDto.parentId}` : null})
                    .then(() => {
                        this.loadFireBase = true;
                        this.onFireBaseSnapshotChange(key)
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            onWriteFireBase(username) {
                this.fireBaseRequest.username = username;
                this.fireBaseRequest.web_status = 'ACTIVE'
                this.fireBaseRequest.android_status = 'DEACTIVATED'
                this.fireBaseRequest.objectId = this.autoDto && this.autoDto.parentId ? `${this.autoDto.parentId}` : null;

                console.log('firebase request = ', this.fireBaseRequest)
                fireBaseDb.collection("users_auto")
                    .add(this.fireBaseRequest)
                    .then((res) => {
                        this.loadFireBase = true;
                        console.log("FireBase successfully created!", res.id)
                        this.fireBaseRequest.key = res.id;
                        this.onShowAlert('success', 'Ҳужжатни сканерлаш учун хабар мобил иловага юборилди! Илтимос мобил иловага киринг!');

                        this.onFireBaseSnapshotChange(res.id)
                    }).catch((err) => {
                    console.log(err);
                })
            },
            onFireBaseSnapshotChange(key) {
                let dbRef =  fireBaseDb.collection("users_auto").doc(key)
                dbRef.onSnapshot((doc) => {
                    const username = this.$store.state.profile.username;
                    let isActiveWeb = doc && doc.data() && doc.data().username === username && doc.data().web_status === 'ACTIVE';
                    if (isActiveWeb && doc.data().android_status === 'ACTIVE') {
                        this.onShowAlert('warning', 'Ҳужжатни сканерлаш жараёнида!')
                    } else if (isActiveWeb && doc.data().android_status !== 'ACTIVE') {
                        this.onShowAlert('error', 'Илтимос мобил иловага киринг! Ҳужжатни сканерланг!')
                    }

                })
            },
            onShowAlert(type, message) {
                this.$swal({
                    position: 'top-end',
                    type: type,
                    text: message,
                    showConfirmButton: false,
                    timer: 3000
                });
            }
        },
        created() {
            this.init();
            this.getAutoFuelType();
            this.$eventBus.$on('receiveForAutoLosesDataFromAndroid', (data) => {
                if (data) {
                    this.autoDto.name=data.name;
                    this.autoDto.address=data.address;
                    this.autoDto.governmentNum=data.governmentNum;
                    this.autoDto.madeYear=data.madeYear;
                    this.autoDto.engineNum=data.engineNum;
                    this.autoDto.bodyNum=data.bodyNum;
                    this.autoDto.shasseNum=data.shasseNum;
                    this.autoDto.autoColor=data.autoColor;
                    this.autoDto.highWeight=data.highWeight;
                    this.autoDto.fullWeight=data.fullWeight;
                    this.autoDto.texPassportNum=data.texPassportNum;
                    this.autoDto.fuelType=data.fuelType;
                    this.loadFireBase = false;
                    this.onShowAlert('success', 'Ҳужжатни сканерлаш якунланди!')
                    this.$v.$touch();
                }
            })
        }
    }
</script>

<style scoped>

</style>
